import React from 'react';
import { RootStyle } from '@ygtechnologies/rubus-ui';
import { useIsSeller } from '@/utils/hooks';
import { isProd } from '@/utils/envRenderLogic';
import { useThemePreference } from './ThemePreferenceContext';

const darkLegacyOverrides: Record<string, string> = {
    '--cm-background-color': 'var(--rui-semantic-surface-page)',
    '--color-content-background': 'var(--rui-semantic-surface-elevated)',
    '--color-button': 'var(--rui-semantic-intent-primary-surface)',
    '--color-button-focus': 'var(--rui-semantic-intent-primary-surface-hover)',
    '--color-button-active': 'var(--rui-semantic-intent-primary-surface-active)',
    '--color-button-contrast': 'var(--rui-semantic-intent-primary-text)',
    '--color-button-secondary': 'var(--rui-semantic-intent-tertiary-surface)',
    '--color-button-secondary-contrast': 'var(--rui-semantic-intent-tertiary-text)',
    '--color-button-disabled': 'var(--rui-semantic-intent-disabled-surface)',
    '--color-button-disabled-contrast': 'var(--rui-semantic-intent-disabled-text)',
};

export const SellerLegacyStyleProvider: React.FC = () => {
    const isSeller = useIsSeller();
    const { themePreference } = useThemePreference();

    if (!isSeller || isProd || themePreference !== 'dark') {
        return null;
    }

    return <RootStyle value={darkLegacyOverrides} />;
};
